import { Component, OnDestroy, OnInit, NgZone, ViewChild } from '@angular/core';
import { APIService } from '../../../api/api.service';
import { NotifierService } from '../../../_services/notifier.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { MrrTabsComponent } from './discount-tabs/discount-tab.component';

declare let window: any;
declare let $: any;

declare let flatpickr: any;
@Component({
  //moduleId: module.id.toString(),
  templateUrl: './mrr.component.html',
  styleUrls: ['./mrr.component.css'],
})
export class NewMRRDiscountComponent implements OnInit, OnDestroy {
  @ViewChild(MrrTabsComponent) mrrTabsRef: MrrTabsComponent;
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  selectedClientName: any;
  // = localStorage.getItem('selectedClientName');
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  delete: boolean = false;
  mrrData: any = [];
  accountId: any;
  deleteall: boolean = false;
  currentMessage: any;
  updateMRR: any;
  updatemrrsub: any;
  period: any;
  updateAction: any = 'update';
  unsavedMRR: any = [];
  unsavedUpdateId: number = -1;
  unselected: any = [];
  deleteMRR: any;
  unselectedServiceString: string;
  deleteSelected: boolean = false;
  dateRange: any;
  delete_selected: boolean = false;
  allSelected: boolean = false;
  headers: any = [
    {
      id: 'serviceName',
      name: 'Service Name',
    },
    {
      id: 'mrrDiscount',
      name: 'MRR Discount',
    },
    {
      id: 'comment',
      name: 'Comment',
    },
  ];

  funRef: any = {};
  list: any;
  showPopup: boolean;
  popupData: any = [];
  mid: any;
  masterAccounts: any;
  date: string;
  headers_pop: { id: string; name: string }[];
  s3Mrr: { isMrr: boolean; perc: number };
  subRds: { instance: {}; others: {} };
  subEc2: {
    instance: {
      ri_sp: {
        isMrr: boolean;
        perc: number;
      };
      od: {
        isMrr: boolean;
        perc: number;
      };
      spot: {
        isMrr: boolean;
        perc: number;
      };
    };
    ebs: {
      isMrr: boolean;
      perc: number;
    };
    others: {
      isMrr: boolean;
      perc: number;
    };
  };
  cfrcMrr: { isMrr: boolean; perc: number };
  s3Keys: any[];
  cfrcKeys: any[];

  constructor(
    private notifier: NotifierService,
    private apiService: APIService,
  ) {}

  ngOnInit(): void {
    this.accountId = localStorage.getItem('accountId');
    this.funRef = {};
    // this.fetchMasterAccounts();
    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }
      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.expandedRow = null;
        this.fetchMasterAccounts();
        // this.load();
      }
    });
    flatpickr('#dataRangePicker', {
      dateFormat: 'Y-m-d',
      mode: 'range',
      showMonths: 2,
      defaultDate: this.dateRange ? this.dateRange.split(' to ') : null,
      onChange: (selectedDates: any, dateStr: any, instance: any) => {
        if (!dateStr.includes('to')) return;
        this.dateRange = dateStr;
      },
    });
    this.date = moment()
      .subtract(1, 'month')
      .startOf('month')
      .format('MM-YYYY');
  }
  mrrDatasub: any = [];
  subloading: any = false;

  setHeadersBasedOnService(serviceName: string) {
    // Define header configurations based on the service name
    if (serviceName === 'Amazon Elastic Compute Cloud') {
      this.headers_pop = [
        { id: 'instanceId', name: 'Instance ID' },

        { id: 'instanceName', name: 'Instance Name' },

        { id: 'instanceType', name: 'Instance Type' },
        { id: 'os', name: 'OS' },
        { id: 'region', name: 'Region' },
      ];
    } else if (serviceName === 'Amazon Relational Database Service') {
      this.headers_pop = [
        // { id: 'key', name: 'Key' },
        { id: 'region', name: 'Region' },
        { id: 'usageType', name: 'Usage Type' },
        { id: 'azType', name: 'Availability Zone Type' },
        { id: 'dbEngine', name: 'DB Engine' },
      ];
    } else if (serviceName === 'Amazon Simple Storage Service') {
      this.headers_pop = [
        // { id: 'key', name: 'Key' },
        { id: 'region', name: 'Region' },
        { id: 'usageType', name: 'Usage Type' },
      ];
    } else if (serviceName === 'Amazon CloudFront') {
      this.headers_pop = [
        // { id: 'key', name: 'Key' },
        { id: 'region', name: 'Region' },
        { id: 'usageType', name: 'Usage Type' },
      ];
    } else {
      // Default headers if the service name does not match
      this.headers_pop = [
        { id: 'serviceName', name: 'Service Name' },
        { id: 'mrrDiscount', name: 'MRR Discount' },
        { id: 'comment', name: 'Comment' },
      ];
    }
  }

  async loadsub(serviceName: any) {
    let data;
    this.notifier.loading(true);
    this.subloading = true;
    if (this.selectedClientName === 'NHA') {
      data = {
        a: 'fetchEc2Mrr',
        lid: this.accountId,
      };
    } else {
      data = {
        a: 'fetchNonNhaMrr',
        lid: this.accountId,
        serviceName: serviceName,
      };
    }
    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/mrr`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);
    if (result.s == '1') {
      if (this.selectedClientName == 'NHA') {
        this.mrrDatasub = result.sub;
      } else {
        this.mrrDatasub = result;
      }
    } else {
      this.mrrDatasub = [];
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }
    this.subloading = false;
    this.notifier.loading(false);
  }

  async load() {
    this.notifier.loading(true);
    // let data = { a: 'fetch', lid: this.accountId };
    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${APIService.API_DISCOUNTENPOINT}?lid=${this.accountId}&action=get&tableType=mrr`;
    let result = await this.apiService.getDataPromis(apiURL, {}, header);
    if (result.status == '1') {
      this.mrrData = result.response;

      if (this.mrrData.length > 0) {
        this.period =
          this.mrrData[0].startDate + ' to ' + this.mrrData[0].endDate;
      }
    } else {
      this.mrrData = [];
      this.period = '-';
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }
    if (this.mrrData.length == 0) {
      this.period = '-';
    }
    this.notifier.loading(false);
  }

  lek: any;
  service_Name: any;

  async fetchDetails(serviceName: any) {
    this.notifier.loading(true);
    const serviceMapping: { [key: string]: string } = {
      'Amazon Simple Storage Service': 's3',
      'Amazon Relational Database Service': 'rds',
      'Amazon CloudFront': 'cfrc',
      'Amazon Elastic Compute Cloud': 'ec2',
    };

    // Get the abbreviated service name from the mapping
    const abbreviatedServiceName = serviceMapping[serviceName] || serviceName;
    let data;
    if (this.lek === null || this.lek === undefined || this.lek === '') {
      data = {
        month: this.date,
        childs: [this.accountId],
        mid: this.mid,
        a: abbreviatedServiceName,
        tableType: 'mrr',
      };
    } else {
      data = {
        month: this.date,
        childs: [this.accountId],
        mid: this.mid,
        a: abbreviatedServiceName,
        lek: this.lek,
        tableType: 'mrr',
      };
    }

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/mrr`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.s == '1') {
      if (
        result.lek === null ||
        result.lek === undefined ||
        result.lek === ''
      ) {
        this.popupData = [...this.popupData, ...result.riDetails];
        this.lek = result.lek;
      } else {
        this.lek = result.lek;
        this.popupData = [...this.popupData, ...result.riDetails];
        // this.fetchDetails(serviceName);
      }
    }
    this.notifier.loading(false);
  }

  async fetchMasterAccounts() {
    this.masterAccounts = [];
    this.notifier.loading(true);
    let data = {
      lid: this.accountId,
      userType: 'C',
      action: 'fetchMasterAccList',
    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    // let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/ec2breakup`;
    let apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/ec2breakup`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.masterAccounts = result.masterAccList;
      this.mid = this.masterAccounts[0];
      //  if(this.mid == 440591205624) {
      //  }

      this.notifier.loading(false);
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
      this.notifier.loading(false);
    }
    this.selectedClientName = localStorage.getItem('selectedClientName');
  }

  async updateTrigger(id: any) {
    this.expandedRow = null;
    if (
      id.serviceName === 'Amazon Elastic Compute Cloud' &&
      this.selectedClientName === 'NHA'
    ) {
      await this.loadsub(id.serviceName);
      this.updatemrrsub = this.mrrDatasub;
    } else if (
      (id.serviceName === 'Amazon Elastic Compute Cloud' ||
        id.serviceName === 'Amazon Relational Database Service' ||
        id.serviceName == 'Amazon CloudFront' ||
        id.serviceName == 'Amazon Simple Storage Service') &&
      this.selectedClientName !== 'NHA'
    ) {
      await this.loadsub(id.serviceName);
      this.updatemrrsub = this.mrrDatasub;
    }
    this.updateAction = 'update';
    this.updateMRR = id;
  }
  indexdelete: any;
  confirmdeletion(i: any) {
    this.delete = true;
    this.indexdelete = i;
  }

  deleteUnsavedMRR(id: number) {
    let removed = this.unsavedMRR.splice(id, 1)[0].serviceName;
    this.unselected.push(removed);
    this.unselectedServiceString = this.unselected.join(', ');
  }

  updateUnsavedMRR(id: any, index: number) {
    this.updateAction = 'add';
    this.unsavedUpdateId = index;
    this.updateMRR = id;
  }

  closeUpdateTrigger(event: any) {
    this.updateMRR = null;
    if (!event || !this.mrrTabsRef) return;

    const tabId = this.resolveAddTabId(event);
    this.mrrTabsRef.activeTabId = tabId;
    this.mrrTabsRef.loadTab(tabId);
  }

  private resolveAddTabId(type: any): string {
    if (!type || type === true) return 'mrr';
    const map: Record<string, string> = {
      mrr: 'mrr',
      s3: 's3',
      cfrc: 'cfrc',
      ec2: 'ec2',
      'rds-ri': 'rdsri',
    };
    return map[type] ?? 'mrr';
  }

  expandedRow: number | null = null; // Track which row is expanded
  exp_row: any;
  async toggleExpandRow(index: number) {
    console.log('index', index);
    console.log(this.mrrData[index]);
    let heders_exp;

    // Check if the row is being expanded (not already expanded)
    if (this.expandedRow !== index) {
      // Only load the sub data when expanding the row
      const serviceName = this.mrrData[index].serviceName;
      this.exp_row = serviceName;
      await this.loadsub(serviceName);
      this.expandedRow = index; // Expand the row
    } else {
      // If the row is already expanded, collapse it
      this.expandedRow = null;
    }
  }

  closeDeleteTrigger(event: any) {
    this.deleteMRR = null;
  }

  del_selectedServices: any;
  deleteSel() {
    this.del_selectedServices = this.mrrData
      .filter((row: any) => row.isSelected)
      .map((row: any) => row.serviceName);

    this.delete_selected = true;
  }

  isAnyRowSelected: boolean = false;
  checkSelection() {
    this.isAnyRowSelected = this.mrrData.some((row: any) => row.isSelected);
  }

  allSelection() {
    this.mrrData.forEach((row: any) => {
      row.isSelected = this.allSelected; // Set all checkboxes based on 'allSelected'
    });
    this.isAnyRowSelected = this.allSelected; // Update the selection flag
  }

  addMrr() {
    this.updateAction = 'add';
    this.unsavedUpdateId = -1;

    // Initialize updateMRR
    this.updateMRR = {
      serviceName: '',
      mrrDiscount: 0,
      comment: '',
      serviceType: '',
    };

    // Initialize updatemrrsub
    this.updatemrrsub = {
      instance: 0,
      ebs: 0,
      others: 0,
    };

    // Initialize subEc2
    this.subEc2 = {
      instance: {
        ri_sp: {
          isMrr: false,
          perc: 0,
        },
        od: {
          isMrr: false,
          perc: 0,
        },
        spot: {
          isMrr: false,
          perc: 0,
        },
      },
      ebs: {
        isMrr: false,
        perc: 0,
      },
      others: {
        isMrr: false,
        perc: 0,
      },
    };

    // Initialize subRds
    this.subRds = {
      instance: {
        ri_sp: {
          isMrr: false,
          perc: 0,
        },
        od: {
          isMrr: false,
          perc: 0,
        },
      },
      others: {
        isMrr: false,
        perc: 0,
      },
    };

    // Initialize s3Mrr and cfrcMrr
    this.s3Mrr = {
      isMrr: false,
      perc: 0,
    };

    this.cfrcMrr = {
      isMrr: false,
      perc: 0,
    };
  }

  callFunction(param: any, id: any) {
    this.funRef[param](this, id);
  }

  ngOnDestroy(): void {
    this.currentMessage.unsubscribe();
  }
}
